import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/Button/button';
import { useVideoSources } from '@/hooks/useVideoSources';
import { openEmailClient } from '@/libs/auth/emailProviderRedirect';
import openModal from '@/modals/utils/openModal';

interface Props {
  email: string;
  onCloseAction?: () => void;
}

const VIDEO_SOURCES = [
  { src: '/videos/auth/complete-registration/complete-registration-ios.mov', type: 'video/quicktime' },
  { src: '/videos/auth/complete-registration/complete-registration.webm', type: 'video/webm' },
];

const CompleteRegistration = ({ email, onCloseAction }: Props) => {
  const t = useTranslations('register');
  const { videoProps, sources } = useVideoSources({
    sources: VIDEO_SOURCES,
  });

  const handleGoToEmail = () => {
    openEmailClient(email);
    onCloseAction?.();
    openModal('register');
  };

  return (
    <>
      <div className="absolute top-0 h-full left-0 w-full overflow-x-hidden">
        <div className="relative h-full w-full flex flex-col justify-between">
          <div>
            <div className="relative w-full flex justify-center items-center">
              <video
                {...videoProps}
                muted
                aria-label="Complete register"
                className="w-full h-auto max-w-100"
              >
                {sources.map(source => (
                  <source key={source.src} src={source.src} type={source.type} />
                ))}
              </video>
            </div>
            <div className="absolute top-18 left-1/4 w-[130%] h-[30%] bg-frame-gradient z-[-1] blur-[5rem] sm:blur-[6.5rem] lg:blur-[4.5rem] rounded-full opacity-70 rotate-[165deg]"></div>

            <div className="px-5 text-light -mt-6 lg:-mt-10.75">
              <p className="font-medium text-xl leading-[130%]   text-center mb-2">
                {t('request-sent')}
              </p>
              <p className="text-sm leading-5 font-regular text-center max-w-69 mx-auto">
                {t('request-sent-description')}
              </p>
            </div>
          </div>

          <div className="px-4 lg:px-6.5  mt-4 mb-6 lg:mb-7.75 flex justify-center">
            <Button
              onClick={handleGoToEmail}
              variant="primary"
              className="w-full font-medium  leading-5 py-3 text-sm text-light"
            >
              {t('go-to-email')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompleteRegistration;
